import StopIcon from '@assets/images/icons/stop.svg?react'
import IconX from '@lib/icons/IconX'
import { Tooltip } from '@octopus-do/octopus-storybook'
import type React from 'react'

import css from './styles.module.css'

interface Props {
  percent: number
  scanned: number
  total: number
  url: string
  saving: boolean
  onCancel: () => void
  onStop: () => void
}

// Takes the place the counters and the status bar hold when the report is at
// rest: the same bar, filling up, and under it the address the crawl is on.
export const CrawlProgress: React.FC<Props> = ({
  percent,
  scanned,
  total,
  url,
  saving,
  onCancel,
  onStop,
}) => {
  const width = saving ? '100%' : `${percent}%`

  return (
    <div className={css.crawl_progress}>
      <div className={css.bar}>
        <div className={css.fill} style={{ width }} />
      </div>

      <div className={css.status}>
        <div className={css.label}>
          {saving ? 'Saving the crawl:' : 'Crawling:'}
        </div>

        {!saving && (
          <div className={css.actions}>
            {/* The queue is only known once the crawl has walked some of it —
                until then there is nothing to count against. */}
            {total > 0 && (
              <div className={css.count}>
                {scanned} of {total}
              </div>
            )}

            <Tooltip label="Stop crawling and keep discovered pages">
              <button className={css.stop} type="button" onClick={onStop}>
                <StopIcon />
                Stop
              </button>
            </Tooltip>

            <div className={css.divider} />

            <Tooltip label="Cancel crawling">
              <button
                aria-label="Cancel crawling"
                className={css.cancel}
                type="button"
                onClick={onCancel}
              >
                <IconX size={16} />
              </button>
            </Tooltip>
          </div>
        )}
      </div>

      {/* Always in the layout, empty or not: the block below must not move
          when the crawl hands over. */}
      <div className={css.url}>{saving ? null : url}</div>
    </div>
  )
}
